import React from 'react';
const textData = [
  {
    heading: 'Luxury Redefined: Private Tours by See Sight Tours',
    paragraph:
      "Embark on a journey of unparalleled luxury and discovery with See Sight Tours' private tours across the captivating landscapes of North America. "
  },
  {
    heading: 'Elevate to VIP Status',
    paragraph:
      "Elevate your travel experience to VIP status and immerse yourself in the wonders of this vast continent with our high-end services tailored to your preferences. Picture this: You're comfortably seated in an air-conditioned Mercedes Metris van, cruising through the breathtaking landscapes of North America. The exclusivity of the experience hits you as you realize you're not just on a tour, but a personal adventure curated just for you.  "
  },
  {
    heading: 'Convenience Redefined ',
    paragraph:
      "Our commitment to luxury extends to every detail, from the plush seating to the attentive guides who cater to your every need. But the luxury doesn't stop there. Imagine being picked up and dropped off at your downtown hotel, hassle-free and convenient. No need to worry about transportation logistics or finding your way – we've got it all covered. "
  },
  {
    heading: 'Intimate Exploration ',
    paragraph:
      "What truly sets us apart is our dedication to keeping things intimate. Our small-group guided tours are limited to just seven people, ensuring that you receive personalized attention and can engage with your guide on a deeper level. It's not just a tour guide you're getting; it's a knowledgeable companion who shares fascinating insights about each destination. "
  },
  {
    heading: 'Seamless Adventure ',
    paragraph:
      "And let's not forget the best part – admission to all attractions is included. No standing in lines, no fussing over tickets. You can fully immerse yourself in the experience, from iconic landmarks to hidden gems, without any worries. "
  },
  {
    heading: 'Reimagining Exploration',
    paragraph:
      "In essence, See Sight Tours redefines exploration. It's not just a tour; it's an invitation to discover North America's wonders in utmost comfort and style. Get ready to embark on a journey that's exclusively yours – a journey that marries opulence with adventure!"
  }
];
const PrivateText = () => {
  return (
    <div className="flex flex-col gap-5 mt-[5%]  w-[90%] lg:w-[80%] 3xl:w-[70%]  max-w-[1750px] mx-auto">
      {textData.map(item => (
        <div className="flex flex-col gap-2  mb-2    " key={item.heading}>
          <h2 className=" text-xl lg:text-2xl font-semibold ">
            {item.heading}
          </h2>
          <p className=" text-base lg:text-lg">{item.paragraph}</p>
        </div>
      ))}
    </div>
  );
};

export default PrivateText;
